/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '../theme/theme';
import type { SpaceKey } from '../theme/theme';

export interface ClusterProps {
  children: ReactNode;
  gap?: SpaceKey;
  /** 주축 정렬. 필터바처럼 양끝 벌릴 때 between. */
  justify?: 'start' | 'between' | 'end';
  /** 교차축 정렬. 사이드바+본문처럼 위 맞춤은 start. */
  align?: 'start' | 'center';
}

/** 가로 나열 프리미티브. 필터 컨트롤 줄, 버튼 묶음에 활용. */
export function Cluster({ children, gap = 'sm', justify = 'start', align = 'center' }: ClusterProps) {
  const justifyMap = { start: 'flex-start', between: 'space-between', end: 'flex-end' } as const;
  const alignMap = { start: 'flex-start', center: 'center' } as const;
  return (
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: ${theme.space[gap]}px;
        justify-content: ${justifyMap[justify]};
        align-items: ${alignMap[align]};
      `}
    >
      {children}
    </div>
  );
}
